export enum Roles {
  EMPLOYEE = 'ROLE_EMP',
  BOOKEEPER = 'ROLE_BK'
}

